<template>
  <h2 class="h3" :class="shoppableRedesignOptimization ? 'margin-bottom-s' : 'margin-bottom-m'">
    Choose Your Items ({{ memberProductsByGroup.length }})
  </h2>

  <Form v-if="isMobile" class="margin-bottom-xl">
    <Dropdown v-model="activeTab" name="latch-keys" :options="options" label-size="none" />
  </Form>

  <Tabs
    v-else
    class="cell large-12 small-margin-bottom-xl large-margin-bottom-m"
    :tabs="latchKeyGroups"
    :initial-tab="activeTab"
    @tab-click="handleTabClick"
  />

  <slot name="member-products-list" :list="memberProductsByGroup"></slot>
</template>

<script setup>
import { computed, ref } from 'vue';
import Tabs from '@atomic-ui/tabs/Tabs';
import Form from '@atomic-ui/form';
import Dropdown from '@atomic-ui/dropdown/Dropdown';

import useMembersOfProduct from '~/composables/useMembersOfProduct';
import useLatchkey from '~/modules/latchkey/composables/useLatchkey';
import { useDeviceType } from '~/composables/utils/useDeviceType';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';

const { isMobile } = useDeviceType();
const { memberProductsMap } = useMembersOfProduct();
const { latchKeyGroups, latchKeyProductIdsByGroup, selectedLatchkey } = useLatchkey();
const { shoppableRedesignOptimization } = useFeatureEligibility();

/**
 * @returns {Number}
 */
function getInitialLatchKey() {
  const index = latchKeyGroups.value.findIndex((latchKey) => latchKey.trim().toLowerCase() === selectedLatchkey.value.trim().toLowerCase());

  return index === -1 ? 0 : index;
}

const initialLatchKey = getInitialLatchKey();
const activeTab = ref(latchKeyGroups.value[initialLatchKey]);
const options = computed(() =>
  latchKeyGroups.value.map((name) => ({
    value: name,
    displayValue: name,
  })),
);
const memberProductsByGroup = computed(() =>
  latchKeyProductIdsByGroup.value[activeTab?.value?.toString()].filter((key) => Object.hasOwn(memberProductsMap.value, key)),
);

/**
 *
 * @param {number} _index
 * @param {string} _prev
 * @param {string} newValue
 */
function handleTabClick(_index, _prev, newValue) {
  activeTab.value = newValue;
}
</script>
